export const GlobalDirective = (app) => {
    app.directive('visible', {
        mounted(el, binding) {
            el.style.visibility = binding.value ? 'visible' : 'hidden';
        },
    });
};
